import { pluralize } from '../../../../modules/Dispatch/RouteExecution/DriverPopUp/common/utils';
import { OTHER_ROUTE_TYPES, OTHER_ROUTES_COMMENTS } from '../constants';

const getHoursMinutesAndSecondsStr = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${pluralize(hours, 'hour')} ${pluralize(minutes, 'min')} ${pluralize(seconds, 'sec')}`;
  }

  if (minutes > 0) {
    return `${pluralize(minutes, 'min')} ${pluralize(seconds, 'sec')}`;
  }

  return pluralize(seconds, 'sec');
};

const getAffectedRoutes = (data) => {
  const { cityRoutes = [], otherRoutes = {} } = data;

  // Extract routes from cityRoutes
  const cityRouteNames = cityRoutes.flatMap((routeItem) =>
    Array.isArray(routeItem.routes) ? routeItem.routes : []
  );

  // Extract routes from otherRoutes
  const otherRouteNames = Object.values(otherRoutes).flatMap((routeArray) =>
    routeArray.flatMap((routeItem) => (Array.isArray(routeItem.routes) ? routeItem.routes : []))
  );

  // Combine and return all route names
  return [...cityRouteNames, ...otherRouteNames];
};

const processRoutesData = (data, isExtraRoute) => {
  if (!data) return [];
  const dataList = isExtraRoute ? extractNonLateWaveRoutes(data) : formatRouteData(data);
  return dataList;
};

const extractNonLateWaveRoutes = (data) => {
  return Object.keys(data)
    .filter(key => key !== OTHER_ROUTE_TYPES.LATEWAVE) // Filter out LATEWAVE
    .flatMap(key => formatRouteData(data[key], OTHER_ROUTES_COMMENTS[key])); // Use flatMap for cleaner concatenation
};

const formatRouteData = (data, comment) => {
  return data?.map((item) => {
    const routeCount = item.routes.length;
    return {
      trailerType: `${item.trailerName} (${pluralize(routeCount, "Route")})`,
      routes: item.routes.join(', '), // Join routes with a comma and space for better readability
      routeCount,
      comment
    };
  });
};

const getLastWaveRoute = (data) => {
  const lastWaveRoutes = data?.[OTHER_ROUTE_TYPES.LATEWAVE];
  if (!lastWaveRoutes) return null;
  // Using flatMap to combine all routes into a single array
  const allRoutes = lastWaveRoutes.flatMap((route) => route.routes);
  return allRoutes?.length > 0 ? allRoutes.join(', ') : null; // Return the first route or null if it doesn't exist
};

const getRoutesCount = (data) => {
  if (!data?.length) return 0;
  return data.reduce((count, item) => count + (item.routeCount || 0), 0);
};

const isEmptyDriverPreference = (data) => {
  // Check if startTime is available
  return !data.startTime;
};

const getDefaultDriverPreference = () => {
  return {
    startTime: null,
    driverCount: 0
  };
};
export {
  getHoursMinutesAndSecondsStr,
  processRoutesData,
  getLastWaveRoute,
  getAffectedRoutes,
  getRoutesCount,
  isEmptyDriverPreference,
  getDefaultDriverPreference
};
